import { connect } from 'react-redux';
import { get } from 'lodash';
import { getSelectedMapLayer, getSelectedManagementZonesType } from 'manual/selectors';
import { formatDate } from 'util/formatters/dateFormatter';
import { locale } from '@tcc/i18n';
import { getMessage } from 'util/locale';
import { managementZonesTypes } from 'constants/scripts';

// selectors
import {
  getActiveFarm,
  getActiveField,
  getActiveRoute,
  getActiveScript,
  getActiveScriptMethod,
  getActiveScriptType,
  isFieldFecthed
} from 'current/selectors';
import {
  getTotalAreaForZones
} from 'util/zoneOperations';

import FieldInfo from './FieldInfo';

export default connect(
  (state, ownProps) => {
    const { isVisible, showOwnerName, showScriptFlow } = ownProps;
    const zones = Object.values(get(getActiveScript(state), 'zones', {}));
    const selectedMapUuid = get(getSelectedMapLayer(state), 'selectedMapUuid');
    const selectedMapDate = selectedMapUuid ? formatDate(selectedMapUuid, { locale }) : '';
    const manualSelectedDate = selectedMapDate
      ? getMessage(`title-text__create-manualv2-generate-zones--review-header--scouting`, { date: selectedMapDate })
      : '';
    const isManualV2 = getSelectedManagementZonesType(state) === managementZonesTypes.GENERATE_ZONES
      && getActiveRoute(state) === 'edit'
      && manualSelectedDate;
    const activeField = getActiveField(state);
    const isFetched = isFieldFecthed(state);

    return {
      activeFarm: activeField?.farm ?? getActiveFarm(state),
      activeField,
      activeScriptMethod: getActiveScriptMethod(state),
      activeScriptType: getActiveScriptType(state),
      areaFromZones: getTotalAreaForZones(zones),
      isVisible,
      showManualSelectedDate: {isManualV2, manualSelectedDate},
      showOwnerName,
      showScriptFlow,
      isFetched
    };
  }
)(FieldInfo);
